/** @format */
import { ParsedUrlQuery } from 'querystring';

import { toSnakeCase } from '@toucan/common/helpers/change-case';

import { getSearchParamsFromQuery } from '../helpers';
import { FilterQuery, SortBy } from '../types';
import { PRODUCT_SORT_OPTIONS } from './constants';
import { ProductSearchParams } from './types';

export function getProductSearchParams(
    query: ParsedUrlQuery
): ProductSearchParams {
    const { pageIndex, showAll, selectedFilters, variants, sort } =
        getSearchParamsFromQuery(query);

    const filterQuery = Object.entries(selectedFilters).reduce<FilterQuery>(
        (filters, [facet, value]) => {
            if (value !== undefined) {
                filters[facet] = value;
            }

            return filters;
        },
        {}
    );

    return {
        pageIndex: Number.isFinite(pageIndex) && pageIndex > 0 ? pageIndex : 0,
        showAll,
        filterQuery,
        variants,
        sort,
    };
}

export function getProductSortOption(sort: SortBy) {
    const [facet] = Object.keys(sort);

    if (!facet) {
        return PRODUCT_SORT_OPTIONS[0];
    }

    return (
        PRODUCT_SORT_OPTIONS.find(
            (option) =>
                option.direction === sort[facet] &&
                (option.facet === facet || option.facet === toSnakeCase(facet))
        ) ?? PRODUCT_SORT_OPTIONS[0]
    );
}

export function getProductListingSortBy(sort: SortBy): SortBy {
    const { facet, direction } = getProductSortOption(sort);

    if (facet === 'product_price') {
        return { [facet]: direction, product_sku: 'ASC' };
    }

    return { [facet]: direction };
}

export function getProductResultsRows(
    pageIndex: number,
    resultsPerPage: number
): number {
    return (pageIndex + 1) * resultsPerPage;
}
